export default __webpack_public_path__ + "static/media/documenter.db166686.svg";